module.exports = __webpack_public_path__ + "img/users.6b6ef046.svg";